import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { homepageCTATealium } from "../../TealiumEvents";
import { isExternalLink } from "../../utils";

export const HomeCard = ({ col }) => {
  const { buttonUrl, buttonText, image, title, content } = col;

  const isAExternalLink = isExternalLink(buttonUrl);
  const LinkComponent = isAExternalLink ? "a" : Link;
  const linkProps = isAExternalLink
    ? {
        href: buttonUrl,
        target: "_blank",
        rel: "noopener noreferrer",
      }
    : { to: buttonUrl };

  return (
    <Card
      className="box-shadow flex-grow-1 homepage-card position-relative float-on-hover"
      onClick={() => homepageCTATealium(buttonText, title)}
      data-testid="home-card"
    >
      {/* Make the whole card clickable */}
      <LinkComponent {...linkProps} className="stretched-link" data-testid="home-card-link" />

      <Card.Img variant="top" src={image} alt={title} />
      <Card.Title className="p-3 m-0">{title}</Card.Title>
      <Card.Text className="px-3 flex-grow-1" dangerouslySetInnerHTML={{ __html: content }} />

      {buttonText.trim() && (
        <Card.Footer>
          <div className="btn btn-primary btn-block btn-lg">{buttonText}</div>
        </Card.Footer>
      )}
    </Card>
  );
};
